const buildFlagStyles = (combinedFlags: Record<string, string>): string[] => {
    const inlineStylesArray: string[] = [];

    Object.entries(combinedFlags).forEach(([key, flagValue]) => {
        if (flagValue === undefined || flagValue === null) return;

        inlineStylesArray.push(`
          [data-test-variant="${key}_${flagValue}"] {
            display: contents !important;
          }
        `);
    });

    return inlineStylesArray;
};

export default buildFlagStyles;
